export default "__VITE_ASSET__0e4b1a64__"